import { combineReducers } from 'redux';

import { baseApi } from '#app/api';
import {funnelActivesRatingsSliceReducer} from '#app/components/funnel/actives/model/funnelActivesRatingsSlice';
import funnelActivesReducer from '#app/components/funnel/actives/model/funnelActivesSlice';
import duplicatesReducer from '#app/components/funnel/duplicates/model/duplicatesSlice';
import funnelDataReducer from '#app/components/funnel/statistics/model/funnelDataSlice';
import funnelUser from '#app/components/funnel/statistics/model/funnelUserSlice';
import applicationsSliceReducer from '#app/store/RTK/slices/applicationsSlice';
import atonSliceReducer from '#app/store/RTK/slices/atonSlice';
import calendarSliceReducer from '#app/store/RTK/slices/calendarSlice';
import chatSliceReducer from '#app/store/RTK/slices/chatSlice';
import clientPayments from '#app/store/RTK/slices/clientPaymentsSlice';
import {clientRatingsSliceReducer} from '#app/store/RTK/slices/clientRatingsSlice';
import clientServicesSliceReducer from '#app/store/RTK/slices/clientServicesSlice';
import clientSliceReducer from '#app/store/RTK/slices/clientSlice';
import {clientValuationsSliceReducer} from '#app/store/RTK/slices/clientValuationsSlice';
import contactsSliceReducer from '#app/store/RTK/slices/contactsSlice';
import featureFlagsSliceReducer from '#app/store/RTK/slices/featureFlagsSlice';
import notificationsSliceReducer from '#app/store/RTK/slices/notificationsSlice';
import selectedClientIdsReducer from '#app/store/RTK/slices/selectedClientIdsSlice';
import servicesConstructorReducer from '#app/store/RTK/slices/servicesSlice';
import settingsSliceReducer from '#app/store/RTK/slices/settingsSlice';
import tasksSliceReducer from '#app/store/RTK/slices/tasksSlice';

import auth from './auth';
import i18n from './i18n';
import interfaceComponents from './interface';
import jobs from './jobs';
import menuReducer from './menuReducer';
import task from './task';

import '#app/api/registerEndpoints';

export default () => combineReducers({ // @TODO всё, что можно увести в слайсы ртк, лучше увести в слайсы
    auth,
    jobs,
    interfaceComponents,
    i18n,
    task,
    funnelUser,
    clientPayments,
    aton: atonSliceReducer,
    clientServices: clientServicesSliceReducer,
    client: clientSliceReducer,
    clientRatings: clientRatingsSliceReducer,
    settings: settingsSliceReducer,
    selectedClientIds: selectedClientIdsReducer,
    contacts: contactsSliceReducer,
    applications: applicationsSliceReducer,
    chat: chatSliceReducer,
    notifications: notificationsSliceReducer,
    tasks: tasksSliceReducer,
    calendar: calendarSliceReducer,
    featureFlags: featureFlagsSliceReducer,
    servicesConstructor: servicesConstructorReducer,
    funnelData: funnelDataReducer,
    funnelActives: funnelActivesReducer,
    funnelActivesRatings: funnelActivesRatingsSliceReducer,
    duplicates: duplicatesReducer,
    clientValuations: clientValuationsSliceReducer,
    menu: menuReducer,
    [baseApi.reducerPath]: baseApi.reducer,
})
